let sentryInitialized = false;
let googleAnalyticsInitialized = false;
let webVitalsInitialized = false;

export const initSentryLazy = async (): Promise<void> => {
  if (sentryInitialized) return;
  sentryInitialized = true;

  try {
    const initSentry = (await import('./sentry')).default;
    initSentry();
  } catch (error) {
    console.error('Failed to initialize Sentry:', error);
  }
};

export const initGoogleAnalyticsLazy = async (): Promise<void> => {
  if (googleAnalyticsInitialized) return;
  googleAnalyticsInitialized = true;

  try {
    const initGoogleAnalytics = (await import('./google-analytics')).default;
    initGoogleAnalytics();
  } catch (error) {
    console.error('Failed to initialize Google Analytics:', error);
  }
};

export const initWebVitalsLazy = async (): Promise<void> => {
  if (webVitalsInitialized) return;
  webVitalsInitialized = true;

  try {
    const { initWebVitals } = await import('@/shared/services/webVitalsService');
    initWebVitals();
  } catch (error) {
    console.error('Failed to initialize Web Vitals:', error);
  }
};

export const initializeAllAsync = async (): Promise<void> => {
  try {
    await Promise.all([
      initGoogleAnalyticsLazy(),
      initWebVitalsLazy(),
    ]);

    setTimeout(() => {
      initSentryLazy();
    }, 2000);
  } catch (error) {
    console.error('Error during async initialization:', error);
  }
};
